import type {inferRouterInputs} from "@trpc/server";
import type {PropertiesToType} from "@common/types/utility";
import type {AppRouter} from "@app-trpc/server/api/trpc/[trpc]";

export type CreateFeedbackDataInput = inferRouterInputs<AppRouter>['feedback']['create'];

export const useFeedbackClient = () => {
  const client = useNuxtApp().$client;

  async function findAll() {
    return client.feedback.findAll.query();
  }

  async function findById(id: number) {
    return client.feedback.findById.query(id);
  }

  async function create(data: CreateFeedbackDataInput): Promise<{
    validationErrors: Partial<PropertiesToType<CreateFeedbackDataInput, string[]>>
  } | undefined> {
    try {
      await client.feedback.create.mutate(data);
    } catch (e) {
      if (isTRPCClientError(e)) { // TODO: simplify
        const zodError = e.data?.zodError;
        return {
          validationErrors: {
            name: zodError?.name?._errors,
            email: zodError?.email?._errors,
            message: zodError?.message?._errors,
          }
        }
      }
    }
  }

  async function deleteById(id: number) {
    return client.feedback.delete.mutate(id);
  }

  return {
    findAll,
    findById,
    create,
    deleteById,
  }
}